import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Button,
  Columns,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useStores } from '../../stores';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { titleAndSubtitles } from '../../core-utils/helper-utils/cohortAnalysisHelper';
import Loader from '../../_components/molecules/Loader';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { pageScrollDown } from '../SummaryPage';
import { PATIENT_DETAILS } from '../../core-utils/routes';
import CustomColumnsTable from '../../_components/organisms/CustomColumnsTable';
import {
  columnsDropdownOptions,
  formatMembersListData,
  getCohortDefaultColumns,
  getColumns,
} from '../../core-utils/helper-utils/customColumnsHelper';
import { handleDownloadCSV } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { toJS } from 'mobx';
import CohortAnalysisModal from '../../_components/atoms/CohortAnalysisModal';
import QueryIcon from '../../_components/atoms/Icons/QueryIcon';
import { getTextWithToolTip } from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import { getInfoIcon } from '../../core-utils/helper-utils/infoIconHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import DateFilter from '../../_components/molecules/DateFilter';
import AutocompleteWithCheckBoxes from '../../_components/atoms/Autocomplete';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '40px 0px 66px 63px',
    width: '1234px',
  },
  flex: {
    display: 'flex',
  },
  queryIconGrid: {
    padding: '10px 0px 10px 22px',
  },
  queryDataOverallGrid: {
    margin: '30px 10px 0px 0px',
    height: '44px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #DADEEF',
    width: '1176px',
    borderRadius: '4px',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  queryDataTypography: {
    padding: '10px 10px',
    height: '44px',
    borderRight: '1px solid #DADEEF',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  queryDataGrid: {
    maxWidth: '1377px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: '60px',
  },
  editQueryGrid: {
    padding: '10px 40px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #DADEEF',
  },
  searchBox: {
    display: 'flex',
    gap: '1rem',
    margin: '1rem 0',
  },
});

const MemberList: React.FC = observer(() => {
  const type = 'members';
  const { classes } = useStyles();
  const employerGroupStore = useStores().employerGroupStore;
  const memberSummaryStore = useStores().memberSummaryStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;

  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const navigate = useNavigate();
  const defaultSelectedColumns = getCohortDefaultColumns(type);

  // const previousYearCostSortFields = [
  //   'previousYearCost',
  //   'prevMedicalCost',
  //   'prevRxCost',
  // ];
  const infoIcon = getInfoIcon(
    `Top 3 Diagnosis based on Total Cost.`,
    () => {},
    {
      display: 'flex',
      alignItems: 'center',
    },
  );

  //states
  const [totalPages, setTotalPages] = useState(0);

  const [pageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const [loading, setLoading] = useState<boolean>(false);

  const [memberValues, setMemberValues] = useState<number>(0);
  const [totalMembers, setTotalMembers] = useState<number>(0);

  const [riskMemberListData, setRiskMemberListData] = useState<any[]>([]);
  const [clickedMember, setClickedMember] = useState<string>('');
  const [selectedColumns, setSelectedColumns] = useState<string[]>(
    defaultSelectedColumns,
  );
  const [tableColumns, setTableColumns] = useState<Columns[]>(
    getColumns(defaultSelectedColumns, infoIcon),
  );

  const [memberIds, setMemberIds] = useState<string[]>([]);
  const [selectedMemberIds, setSelectedMemberIds] = useState([]);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [sortField, setSortField] = useState<string>('totalCost');
  const [sortOrder, setSortOrder] = useState<number>(-1);

  //Functions

  const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
    setPageNumber(page);
  };

  const handleMemberClick = (value: string) => {
    setClickedMember(value);
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleChangeColumns = () => {
    setTableColumns(getColumns(selectedColumns, infoIcon));
    getRiskMembersList([]);
  };

  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    setSortField(sortColumnName);
    setSortOrder(sortOrder);
  };

  const handleExportCSV = () => {
    handleDownloadCSV(
      properties.aiqBaseUrl + properties.membersList + '/cohort-csv',
      { ...membersListRequestBody, member_unique_id_list: [], showAll: true },
      `${type}.csv`,
      handleOpenSnackBar,
    );
  };

  const getMemberClaims = async (memberId: string) => {
    return await axios
      .post(
        properties.aiqBaseUrl +
          properties.membersBaseUrl +
          properties.memberDetails,
        {
          ...payload,
          member_unique_id: [memberId],
          claim_id_list: [],
        },
      )
      .then((response) => response.data);
  };

  const membersListRequestBody = {
    pageNumber: pageNumber - 1,
    pageSize: pageSize,
    sortField: sortField,
    sortOrder: sortOrder,
    category: 'chronic',
    max_claim_date: employerGroupStore.employerGroupResponseData.max_claim_date,
    columnList: selectedColumns,
    diagnosis_count: 3,
    diagnosis_sort_field: 'totalPaid',
    ...payload,
  };

  const getRiskMembersList = async (
    queryMemberIds: string[],
    signal?: AbortSignal,
  ) => {
    setLoading(true);

    let response: any;
    try {
      response = await axios.post(
        properties.aiqBaseUrl + properties.membersListCohort,
        { ...membersListRequestBody, member_unique_id_list: queryMemberIds },
        { signal },
      );
    } catch (err: any) {
      if (err.name === 'CanceledError') {
        return;
      }

      handleOpenSnackBar('Failed to fetch risk members list', 'error', 3000);
      setLoading(false);
      return;
    }

    if (response?.status === 200) {
      const updatedData = await Promise.all(
        response?.data?.data?.memberList?.map(async (item: any) => {
          const memberClaimsData = await getMemberClaims(item['Member ID']);
          return {
            ...item,
            claimData: memberClaimsData?.data,
          };
        }),
      );
      setMemberValues(response?.data?.data?.totalMembers);
      setTotalMembers(response?.data?.data?.totalGroupMembers);

      setTotalPages(Math.ceil(response?.data?.data?.totalMembers / pageSize));

      setRiskMemberListData(
        formatMembersListData(updatedData, selectedColumns),
      );

      if (memberIds.length === 0) {
        setMemberIds(response?.data?.data?.all_member_id_list);
      }
      setLoading(false);
    }
  };

  //useEffects

  useEffect(() => {
    const abortController = new AbortController();
    getRiskMembersList(selectedMemberIds, abortController.signal);

    return () => {
      abortController.abort();
    };
  }, [
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    pageNumber,
    sortField,
    sortOrder,
  ]);

  useEffect(() => {
    if (clickedMember) {
      memberSummaryStore.setPathDetails([
        [
          'text',
          titleAndSubtitles[type]?.title,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
        ],
      ]);
      navigate(PATIENT_DETAILS, {
        state: { memberId: clickedMember, patientId: '' },
      });
    }
  }, [clickedMember]);

  const getCohortDetails = () => {
    let finalText: string = '';

    if (
      toJS(cohortDetailsStore.cohortValues)?.['chronic_conditions']?.length > 0
    ) {
      finalText =
        'Chronic Disease is ' +
        (toJS(cohortDetailsStore.cohortValues)?.['chronic_conditions']?.join(
          ' | ',
        ) || '');
    }

    if (toJS(cohortDetailsStore.cohortValues)?.['high_cost_claimants']) {
      finalText =
        finalText +
        ', Member Per Month Cost greater than equal to ' +
        ('$' + toJS(cohortDetailsStore.cohortValues)?.['high_cost_claimants'] ||
          '');
    }

    if (toJS(cohortDetailsStore.cohortValues)?.['multiple_drugs']) {
      finalText =
        finalText +
        ', Drug usage greater than equal to ' +
        (toJS(cohortDetailsStore.cohortValues)?.['multiple_drugs'] || '');
    }

    return getTextWithToolTip(finalText, 150);
  };

  const isCohortSelected = () => {
    return (
      toJS(cohortDetailsStore.cohortValues)?.['chronic_conditions']?.length >
        0 ||
      toJS(cohortDetailsStore.cohortValues)?.['high_cost_claimants'] ||
      toJS(cohortDetailsStore.cohortValues)?.['multiple_drugs']
    );
  };

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  return isPlanDatesLoading ? (
    <Loader />
  ) : (
    <>
      <Grid className={classes.root}>
        <PageTitleAndSubTitle
          title={titleAndSubtitles[type]?.title}
          chip={
            <Grid className={classes.flex}>
              <Typography
                fontSize="17px"
                lineHeight="21px"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
                fontType="semiBold"
                margin="2px 8px 0px 0px"
              >
                for
              </Typography>
              <DateFilter />
            </Grid>
          }
          subTitle={titleAndSubtitles[type]?.subTitle}
          showQueryDataButton={false}
          queryButtonText={isCohortSelected() ? 'Edit Cohort' : 'Add Cohort'}
          queryDataAction={() => {
            cohortDetailsStore.toggleCohortModal(true);
          }}
        />
        <Grid className={classes.searchBox}>
          <AutocompleteWithCheckBoxes
            options={memberIds}
            defaultValue={selectedMemberIds}
            handleChange={(event: any, value: any, reason: any) => {
              setSelectedMemberIds(value);

              if (reason === 'clear') {
                setSelectedMemberIds([]);
                getRiskMembersList([]);
              }
            }}
            width="1030px"
            placeholder="Select Member Ids"
            disableClearAll={false}
          />

          <Button
            label={'Get Details'}
            variant="contained"
            onClick={() => {
              getRiskMembersList(selectedMemberIds);
              setPageNumber(1);
            }}
            width="130px"
          />
        </Grid>

        {isCohortSelected() && (
          <Grid
            container
            direction="row"
            className={classes.queryDataOverallGrid}
          >
            <Grid className={classes.queryIconGrid}>
              <QueryIcon />
            </Grid>
            <Grid className={classes.queryDataGrid}>
              <Typography
                className={classes.queryDataTypography}
                lineHeight="25px"
                fontSize="14px"
                fontType="regular"
              >
                {getCohortDetails()}
              </Typography>
            </Grid>
          </Grid>
        )}

        <Grid id="member-details">
          <CustomColumnsTable
            title={
              <Grid className={classes.flex}>
                <Typography
                  fontSize="16px"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  fontType="semiBold"
                  margin="2px 8px 0px 0px"
                >
                  Member Details
                </Typography>
              </Grid>
            }
            subTitle={`Showing details of ${memberValues} of ${totalMembers} members with claims in the selected period`}
            options={columnsDropdownOptions.filter((_, index) => index !== 2)}
            mandateOptions={['Member ID']}
            selectedItems={selectedColumns}
            setSelectedItems={setSelectedColumns}
            handleChangeColumns={handleChangeColumns}
            handleExport={handleExportCSV}
            columns={tableColumns}
            rowsData={riskMemberListData}
            tableLoading={loading}
            handleMemberClick={handleMemberClick}
            handleSort={handleSort}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            pageNumber={pageNumber}
          />
        </Grid>
        <div id="scroll-top-element" />
        {pageScrollDown('scroll-top-element')}
      </Grid>
      <CohortAnalysisModal
        cohortTypes={['chronic_conditions', 'high_cost_claimants']}
      />
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
});

export default MemberList;
